<script lang="ts" setup>
import { ref, onMounted } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  ratio: {
    type: Number,
    default: 2,
  },
  url: {
    type: String,
    default: '',
  },
  width: {
    type: [Number, String],
    required: true,
  },
  height: {
    type: [Number, String],
    required: true,
  },
});

const images = ref<string[]>([]);
const width = Number(props.width) * props.ratio;
const height = Number(props.height) * props.ratio;
let totalWidth = 0;
// let totalHeight = 0;
const img = new Image();

const sliceImage = () => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  let x = 0;
  const y = 0;

  for (let i = 0; i < Math.ceil(totalWidth / width); i++) {
    ctx?.clearRect(0, 0, width, height);
    ctx?.drawImage(img, x, y, width, height, 0, 0, width, height);
    x += width;

    const imgData = canvas.toDataURL();
    images.value.push(imgData);
  }
};

onMounted(() => {
  if (!props.width || !props.height || !props.url) {
    return;
  }

  const canvas = document.createElement('canvas');
  img.crossOrigin = 'anonymous';
  img.src = props.url;
  img.onload = () => {
    totalWidth = img.width;
    // totalHeight = img.height;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(img, 0, 0);
    sliceImage();
  };
});
</script>

<template>
  <div v-for="(image, index) in images" :key="image" v-bind="$attrs">
    <slot :image="image" :index="index"></slot>
  </div>
</template>
